/**
 * Make a boolean data field.
 * @param name - The name of the data field
 * @param value - The value of the data field
 */
export function makeBooleanDataField(name, value, classification) {
    // eslint-disable-next-line id-denylist
    return makeDataField(name, 1 /* DataFieldType.Boolean */, value, classification);
}
/**
 * Make a data field corresponding to the Aria Int64 data type. Note that
 * JavaScript doesn't actually support Int64 precision on large numbers.
 * @param name - The name of the data field
 * @param value - The value of the data field
 */
export function makeInt64DataField(name, value, classification) {
    return makeDataField(name, 2 /* DataFieldType.Int64 */, value, classification);
}
/**
 * Make a double data field
 * @param name - The name of the data field
 * @param value - The value of the data field
 */
export function makeDoubleDataField(name, value, classification) {
    return makeDataField(name, 3 /* DataFieldType.Double */, value, classification);
}
/**
 * Make a string data field
 * @param name - The name of the data field
 * @param value - The value of the data field
 */
export function makeStringDataField(name, value, classification) {
    // eslint-disable-next-line id-denylist
    return makeDataField(name, 0 /* DataFieldType.String */, value, classification);
}
/**
 * Make a GUID data field
 * !!!WARNING: Only the 1DS Sink has support for Guid types.
 * @param name - The name of the data field
 * @param value - The value of the data field
 */
export function makeGuidDataField(name, value, classification) {
    return makeDataField(name, 4 /* DataFieldType.Guid */, value, classification);
}
function makeDataField(name, dataType, value, classification) {
    return {
        name: name,
        dataType: dataType,
        value: value,
        classification: classification ? classification : 4 /* DataClassification.SystemMetadata */
    };
}
//# sourceMappingURL=DataFieldHelper.js.map